<template>
  <div class="header heghtHeader" v-if="this.flg">
    <div class="styleHeader" style="margin: 0;">
      <div class="fLeft">{{ $t('doctor_in_charge_colon') }} {{ $t('doctor_doctor', {doctor: doctorInfo.name }) }}</div>
      <div class="fRight invisible">{{ $t('output_date_and_time') }} {{ currentDateTime }} &emsp; 00/00</div>
    </div>
    <div class="titleHeader">
      <p style="line-height: 35px;">{{ this.title }}</p>
      <p style="font-size: 13px;position: absolute;top: 5px;right: 0;">{{ $t('name') }}: {{ info.name }}</p>
      <p style="font-size: 13px;position: absolute;top: 25px;right: 0;">患者ID: {{ info.patient_id_for_dr ? info.patient_id_for_dr : "ー" }}</p>
      <p style="font-size: 13px;position: absolute;top: 45px;right: 0;">患者名: {{ info.name_for_doctor ? info.name_for_doctor : "ー" }}</p>
    </div>
  </div>
  <div class="header heghtHeader" v-else>
    <div class="styleHeader">
      <div class="fLeft">{{ $t('doctor_in_charge_colon') }} {{ $t('doctor_doctor', {doctor: doctorInfo.name }) }}</div>
      <div class="fRight invisible">{{ $t('output_date_and_time') }} {{ currentDateTime }} &emsp; 00/00</div>
    </div>
    <div class="titleHeder">
      <h1>{{ this.title }}</h1>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { convertToJPDateTime } from '@/js/commons/commons'
import moment from 'moment'
export default {
  props: {
    title: {
      type: String
    },
    flg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentDateTime: convertToJPDateTime(moment().format('YYYY/MM/DD HH:mm')),
    }
  },
  computed: {
    ...mapState({
      info: state => state.patient.info,
      basic_info: state => state.patient.basic_info,
      doctorInfo: state => state.auth.doctorInfo,
    }),
  },
}
</script>
<style scoped>
  .heghtHeader{
    height: 110px;
  }
  .titleHeader {
    font-size: 23px;
    font-weight: 300;
    text-align: center;
    border-bottom: 4px solid #f98ea1;
    padding: 18px 0px;
    position: relative;
  }
</style>
